// extracted by mini-css-extract-plugin
export var wrapper = "FreshOcean-module--wrapper--1i398";
export var container = "FreshOcean-module--container--2LbEk";
export var texts = "FreshOcean-module--texts--2sUMx";
export var textContainer = "FreshOcean-module--textContainer--yev45";
export var blockContent = "FreshOcean-module--blockContent--1tbaK";
export var imageBlock = "FreshOcean-module--imageBlock--1kFsB";
export var statsContainer = "FreshOcean-module--statsContainer--srCac";
export var stat = "FreshOcean-module--stat--jsMmi";
export var image = "FreshOcean-module--image--caMeW";